export function initExpandableText(): void {
  const expandables = document.querySelectorAll('[data-expandable]')

  expandables.forEach((container) => {
    const content = container.querySelector('[data-expandable-content]') as HTMLElement | null
    const toggle = container.querySelector('[data-expandable-toggle]') as HTMLElement | null

    if (!content || !toggle) return

    // Store original line-clamp classes (including responsive variants like md:line-clamp-4)
    const lineClampClasses = Array.from(content.classList).filter((c) => c.includes('line-clamp-'))

    // Check if text is actually truncated
    const isTruncated = content.scrollHeight > content.clientHeight

    if (isTruncated) {
      toggle.classList.remove('hidden')
    }

    let isExpanded = false

    toggle.addEventListener('click', () => {
      isExpanded = !isExpanded

      if (isExpanded) {
        // Expand: remove all line-clamp classes
        lineClampClasses.forEach((c) => content.classList.remove(c))
        toggle.textContent = toggle.dataset.lessText || 'Read less'
      } else {
        // Collapse: restore original line-clamp classes
        lineClampClasses.forEach((c) => content.classList.add(c))
        toggle.textContent = toggle.dataset.moreText || 'Read more'
      }
    })
  })
}
